<template>
  <div class="riskypaws-guide">
    <h1 class="centered-title">{{ $t(titleKey) }}</h1>
    <!-- Tips Cards -->
    <div 
      v-for="(tip, index) in tips" 
      :key="index" 
      :class="['tip-card', tip.level]" 
      @click="navigateToTip(tip)"
    >
      <img :src="require('@/assets/' + tip.image)" alt="Tip Image" class="tip-image" />
      <div class="text-section">
        <h2>{{ $t(tip.headlineKey) }}</h2>
        <h3>{{ $t(tip.descriptionKey) }}</h3>
      </div>

      
    </div>  <!-- Button Container -->
    <div class="button-container">
      <button @click="goBack" class="action-button back-button">
        <i class="fa fa-arrow-left"></i> {{ $t(ArrowbackKey) }}
      </button>
      <button @click="goToKYC" class="action-button next-button">
        {{ $t(ArrownextKey) }}<i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div><br><br><br><br><br><br>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();

    const titleKey = 'saveIntro'; // Add the title key here

    const ArrowbackKey = 'arrowback';
    const ArrownextKey = 'arrownext';

    const tips = ref([
    {
        
        image: '3-save.png',
        headlineKey: 'save1Headline',
        descriptionKey: 'save1Description',
        level: 'beginner',
        route: '/compoundinterestcalculator',
      },
      {
        image: '3-save.png',
        headlineKey: 'save2Headline',
        descriptionKey: 'save2Description',
        level: 'beginner',
        route: '/coolingoff',
      },
      {
        image: '3-save.png',
        headlineKey: 'save3Headline',
        descriptionKey: 'save3Description',
        level: 'beginner',
        route: '/incometaxes',
      },
      {
        image: '3-save.png',
        headlineKey: 'save4Headline',
        descriptionKey: 'save4Description',
        level: 'beginner',
        route: '/taxprovinces',
      },
      {
        image: '3-save.png',
        headlineKey: 'save5Headline',
        descriptionKey: 'save5Description',
        level: 'beginner',
        route: '/investmentaccounts',
      },
      {
        image: '3-save.png',
        headlineKey: 'save6Headline',
        descriptionKey: 'save6Description',
        level: 'beginner',
        route: '/grouprrsp',
      },
      
      {
        image: '3-save.png',
        headlineKey: 'save7Headline',
        descriptionKey: 'save7Description',
        level: 'beginner',
        route: '/tipcalculator',
      },
      
      // Add other tips as needed...
    ]);

    const goBack = () => {
      router.back();
    };

    const goToKYC = () => {
      router.push('/kyc');
    };

    const navigateToTip = (tip) => {
      if (tip.route) {
        router.push(tip.route);
      }
    };

    return {
      tips,
      goBack,
      goToKYC,
      navigateToTip,
      titleKey,
      ArrowbackKey,
      ArrownextKey
    };
  },
};
</script>



<style scoped>
.riskypaws-guide {
  background: linear-gradient(135deg, #36454f 0%, #5a6978 50%, #b0bec5 100%);
  color: white; /* Adjust text color for better contrast and readability against the grey gradient */
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.guide-title {
  color: #FFFFFF; /* White text color */
  text-align: center;
  margin-bottom: 40px;
  font-weight: 700;
}

.tip-card {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #C0C0C0; /* Silver border */
  background-color: #FFFFFF; /* White background for the card */
  color: #333; /* Dark text for contrast */
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.tip-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.tip-image {
  width: 60px;
  height: 60px;
  margin-right: 25px;
}

.text-section {
  flex-grow: 1;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.action-button {
  padding: 10px 25px;
  border: none;
  border-radius: 25px;
  font-weight: bold;
  transition: background-color 0.3s, color 0.3s;
  font-size: 16px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.back-button {
  background-color: #FFFFFF; 
  color: #4A148C; /* Deep purple text */
}

.next-button {
  background-color: #FFFFFF; 
  color: #4A148C; /* Deep purple text */
}

.action-button:hover {
  background-color: #333333; /* Darker background on hover */
  color: #FFFFFF; /* White text on hover */
}

.action-button .fa {
  margin-right: 8px;
}

.centered-title {
  text-align: center; /* This centers the text horizontally */
  /* You can also add other CSS styles as needed for vertical alignment, font size, etc. */
}
</style>